module.exports = __webpack_public_path__ + "media/images/writer/emailer/recommended-label-2db91c2f45265924a560eb35dd1cbedd.png";